<template>
    <Breadcrumbs main="Ui Kits" title="Popover" />
    <div class="container-fluid">
        <div class="row popover-main">
            <basicPopover />
            <directionPopover />
            <offsetPopover />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const basicPopover = defineAsyncComponent(() => import("@/components/theme/uikits/popover/basicPopover.vue"))
const directionPopover = defineAsyncComponent(() => import("@/components/theme/uikits/popover/directionPopover.vue"))
const offsetPopover = defineAsyncComponent(() => import("@/components/theme/uikits/popover/offsetPopover.vue"))
</script>